<div class="main">
  <div class="content">
    <div class="icon-text">
      <div>
        <span style="color: black;font-weight: 500;font-size: 18px;"><img class="bell-icon"
            src="/assets/images/hand.png" style="margin-right: 3px;margin-bottom: 6px;" alt=""> Welcome</span><br>
        <span style="color: black;margin-left: 35px;">Have a nice day at work</span>
      </div>
      <div class="daterange">
        <button class="header-btn" (click)="openDateRangePicker()">
          <img style="width: 12px;margin-left: 3px;margin-right: 8px;margin-bottom: 2px;"
            [src]="bucketurl + '/images/calender.png'" alt="">Date Range
        </button>
        <!-- <mat-form-field appearance="outline">
          <mat-label>Date Range</mat-label>
          <mat-date-range-input [rangePicker]="picker" [max]="today">
            <input matStartDate placeholder="Start date" readonly [(ngModel)]="startDate" name="start"
              (dateChange)="onDateRangeChange()" (click)="picker.open()">
            <input matEndDate placeholder="End date" readonly (click)="picker.open()" [(ngModel)]="endDate" name="end"
              (dateChange)="onDateRangeChange()">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field> -->
      </div>
    </div>
  </div>
  <div class="row date-display justify-content-end mb-3" style="margin-right:-5px">
    <div class="col-auto styled-date-box">
      <span class="date-label-dash" *ngIf="startDate">From:</span> <span class="date-value-dash">{{startDate |
        date:'dd-MMM-yyyy'}}</span>
      <span class="date-label-dash" *ngIf="endDate">To:</span> <span class="date-value-dash">{{endDate |
        date:'dd-MMM-yyyy'}}</span>
    </div>
  </div>
  <div class="row">
    <div class="col-3" *ngFor="let card of cards">
      <div class="card card-hover">
        <div class="card-item">
          <span>
            <img class="mr-3" [src]="bucketurl + '/icons/' + card.icon + '.png'" alt="">
          </span>
          <div class="item-card-val">
            <span>{{ card.title }}</span>
            <p>{{ card.value }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- graph -->
<div class="graph">
  <div class="d-flex justify-content-between align-items-center">
    <h1 style="font-size: 20px;font-weight: 600;">Lead Stages</h1>
    <div class="comparison d-flex align-items-cente">
      <span class="comparebtn" (click)="onclick()">Compare
        <img class="ml-2 logo-white" [src]="bucketurl + '/icons/calendar.png'" alt="">
      </span>
      <div *ngIf="visible" class="datepick d-flex align-items-cente">
        <div>
          <input type="text" class="form-control" [bsConfig]="bsConfig" #dp1="bsDatepicker" bsDatepicker readonly
            (keydown)="preventTyping($event)" [(bsValue)]="firstMonth" placeholder="Select Month">
        </div>
        <span class="m-2">To</span>
        <div>
          <input type="text" class="form-control" [bsConfig]="bsConfig" #dp2="bsDatepicker" bsDatepicker readonly
            (keydown)="preventTyping($event)" [(bsValue)]="secondMonth" placeholder="Select Month">
        </div>
        <div>
          <button class="btn compare" (click)="compareMonths()" type="button">
            <i class="fa fa-exchange-alt" title="Compare"></i>
          </button>
          <button class="btn btn-secondaryd clear" (click)="clearComparison()">
            <i class="fa fa-times-circle" title="Clear Comparison"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!nodata" id="chart">
    <apx-chart [series]="chartOptions.series!" [chart]="chartOptions.chart!" [dataLabels]="chartOptions.dataLabels!"
      [plotOptions]="chartOptions.plotOptions!" [yaxis]="chartOptions.yaxis!" [xaxis]="chartOptions.xaxis!"
      [legend]="chartOptions.legend!" [colors]="chartOptions.colors!" [grid]="chartOptions.grid!"></apx-chart>
  </div>
  <div *ngIf="nodata" class="no-data-available">
    <img [src]="bucketurl + '/images/no-data-available.png'" alt="">
  </div>
</div>
<!-- Second graph -->
<div class="graph">
  <div class="d-flex justify-content-between align-items-center">
    <h1 style="font-size: 20px;font-weight: 600;">Lead Distribution</h1>
    <div class="comparison d-flex align-items-center">
      <span class="comparebtn" (click)="onclick2()">Compare
        <img class="ml-2 logo-white" [src]="bucketurl + '/icons/calendar.png'" alt="">
      </span>
      <div *ngIf="visible2" class="datepick d-flex align-items-center">
        <div>
          <input type="text" class="form-control" [bsConfig]="bsConfig" #dp3="bsDatepicker" bsDatepicker
            (keydown)="preventTyping($event)" [(bsValue)]="firstMonth1" placeholder="Select Month">
        </div>
        <span class="m-2">To</span>
        <div>
          <input type="text" class="form-control" [bsConfig]="bsConfig" #dp4="bsDatepicker" bsDatepicker
            (keydown)="preventTyping($event)" [(bsValue)]="secondMonth1" placeholder="Select Month">
        </div>
        <div>
          <button class="btn compare" (click)="compareMonths1()" type="button">
            <i class="fa fa-exchange-alt" title="Compare"></i>
          </button>
          <button class="btn btn-secondaryd clear" (click)="clearComparison1()">
            <i class="fa fa-times-circle" title="Clear Comparison"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!nodata2" id="chart">
    <apx-chart [series]="chartOptions1.series!" [chart]="chartOptions1.chart!" [dataLabels]="chartOptions1.dataLabels!"
      [plotOptions]="chartOptions1.plotOptions!" [yaxis]="chartOptions1.yaxis!" [xaxis]="chartOptions1.xaxis!"
      [legend]="chartOptions1.legend!" [colors]="chartOptions1.colors!" [grid]="chartOptions1.grid!"></apx-chart>
  </div>
  <div *ngIf="nodata2" class="no-data-available">
    <img [src]="bucketurl + '/images/no-data-available.png'" alt="">
  </div>
</div>


<div class="leads row">
  <div class="col-4 leadcardData" *ngFor="let lead of leads">
    <div class="leadsCard card-hover">
      <div class="cardVal">
        <div class="item-card" style="margin-left: 20px;">
          <div>
            <span>
              <img [src]="bucketurl + '/icons/' + lead.icon + '.png'" alt="">
            </span>
          </div>
          <div>
            <span class="percent">{{ lead.title }}</span>
            <div class="leads_val">
              <p *ngIf="lead.subTitle !== 'Equal to last month'" style="font-size: 24px;">
                {{ lead.value < 0 ? -lead.value : lead.value }}% </p>
                  <p>{{ lead.subTitle }}</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<div class="rounded-card col-12 pl-0">
  <div class="round-card col-3">
    <ng-container *ngIf="!assignAllleads; else noData">
      <p-chart class="pie-chart" style="width: 190px;" width="190" height="190" type="doughnut"
        [data]="leadToAssignedData" [options]="leadToAssignedOptions" />
      <div class="extra-text mt-2">
        <p>Leads to Assigned - {{assignpercentage}}%</p>
      </div>
    </ng-container>
    <ng-template #noData>
      <div class="empty-data">
        <h1>No data available !</h1>
      </div>
    </ng-template>
  </div>
  <div class="round-card col-3">
    <ng-container *ngIf="!lostAllleads; else noData">
      <p-chart class="pie-chart" style="width: 190px;" width="190" height="190" type="doughnut" [data]="leadToLostData"
        [options]="leadToLostOptions" />
      <div class="extra-text mt-2">
        <p>Leads to Junk - {{lostpercentage}}%</p>
      </div>
    </ng-container>
    <ng-template #noData>
      <div class="empty-data">
        <h1>No data available !</h1>
      </div>
    </ng-template>
  </div>
  <div class="round-card col-3">
    <ng-container *ngIf="!nonsalesAllleads; else noData">
      <p-chart class="pie-chart" style="width: 190px;" width="190" height="190" type="doughnut"
        [data]="leadToNonSalesData" [options]="leadToNonSalesOptions" />
      <div class="extra-text mt-2">
        <p>Leads to Non-Sales - {{nonsalespercentage}}%</p>
      </div>
    </ng-container>
    <ng-template #noData>
      <div class="empty-data">
        <h1>No data available !</h1>
      </div>
    </ng-template>
  </div>
  <div class="round-card col-3">
    <ng-container *ngIf="!touchedUntouchedleads; else noData">
      <p-chart class="pie-chart" style="width: 190px;" width="190" height="190" type="doughnut" [data]="assignedData"
        [options]="assignedOptions" />
      <div class="extra-text mt-2">
        <p>Assigned To Untouched - {{allpercentage}}%</p>
      </div>
    </ng-container>
    <ng-template #noData>
      <div class="empty-data">
        <h1>No data available !</h1>
      </div>
    </ng-template>
  </div>
</div>


<ng-template #dateRangePicker>
  <h4 mat-dialog-title class="ml-3">
    Date Range
    <img class="close-button"  mat-dialog-close src="/assets/images/close.png"  alt="" (click)="reset()">
  </h4>
  <mat-dialog-content class="date-range-picker">
    <div class="date-range-picker__content">
      <div class="date-range-picker__sidebar">
        <button class="date-btn" mat-button class="sidebar-button" [class.selected]="selectedButton === 'today'"
          (click)="selectToday()">Today</button>
        <button mat-button class="sidebar-button" [class.selected]="selectedButton === 'last7'"
          (click)="selectLast7Days()">Last 7 days</button>
        <button mat-button class="sidebar-button" [class.selected]="selectedButton === 'last15'"
          (click)="selectLast15Days()">Last 15 days</button>
          <button mat-button class="sidebar-button" [class.selected]="selectedButton === 'last30'"
          (click)="selectLast30Days()">Last 30 days</button>
        <button mat-button class="sidebar-button" [class.selected]="selectedButton === 'thisMonth'"
          (click)="selectThisMonth()">This Month</button>
        <button mat-button class="sidebar-button" [class.selected]="selectedButton === 'custom'"
          (click)="selectCustom()">Custom</button>
      </div>
      <div class="date-range-picker__main" [ngClass]="{ 'isDateCustom': selectedButton != 'custom'}">
        <!-- <mat-calendar  #startCalendar [maxDate]="today" [(selected)]="startDate" (selectedChange)="onStartDateChange($event)"></mat-calendar>
        <mat-calendar [maxDate]="today" [(selected)]="endDate" (selectedChange)="onEndDateChange($event)"></mat-calendar> -->
        <mat-calendar (selectedChange)="selectedChange($event)" [maxDate]="today" [selected]="dateRange"
          #startCalendar></mat-calendar>
      </div>
    </div>

    <div mat-dialog-actions class="d-flex justify-content-between align-items-center">
      <div class="date-display">
        <span class="date-label" *ngIf="startDate">From:</span> <span class="date-value">{{startDate |
          date:'dd-MMM-yyyy'}}</span>
        <span class="date-label ml-2" *ngIf="endDate">To:</span> <span class="date-value">{{endDate |
          date:'dd-MMM-yyyy'}}</span>
      </div>
      <div>
        <button #cancelButton class="btn white-btn mr-2" type="button" (click)="closeDialog()">Cancel</button>
        <button class="btn blue-btn" type="submit" (click)="applyDateRange()">Apply</button>
      </div>
    </div>
  </mat-dialog-content>
</ng-template>